module.exports = __webpack_public_path__ + "img/boleto.4aebf4f4.png";